export * from './mtrwb-edit/mtrwb-edit.component';
export * from './mtrwc-edit/mtrwc-edit.component';

export * from './mtrwd-edit/mtrwd-edit.component';
export * from './mtrwf-edit/mtrwf-edit.component';
// export * from './mtrwf-edit/mtrwf-tab.component';
export * from './mtrwl-edit/mtrwl-edit.component';
// export * from './mtrwl-edit/mtrwl-tab.component';
